/** Shared "embedded on company detail" vs left-nav rules for device screens. */

export function isEmbedded(companyId: string | undefined): boolean {
	return !!companyId;
}

/**
 * Write chrome: the parent `canWrite` flag when embedded, otherwise the
 * standalone Device Management permission.
 */
export function allowWrites(
	companyId: string | undefined,
	canWrite: boolean | undefined,
	standaloneCanWrite: boolean
): boolean {
	if (isEmbedded(companyId)) {
		return canWrite === true;
	}
	return standaloneCanWrite;
}

/** Route company when embedded; otherwise the caller's fallback company. */
export function ownershipCompanyId(
	companyId: string | undefined,
	fallback: string | undefined
): string | undefined {
	return companyId ?? fallback;
}
